// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --clr-lang: hsl(46, 100%, 50%);
}

.neon-select-container {
  display: inline-block;
  position: relative;
}

.neon-select {
  font-size: 20px;
  background-color: transparent;
  color: var(--clr-lang);
  border: var(--clr-lang) 0.125em solid;
  padding: 0.25em 1em;
  border-radius: 0.25em;
  cursor: pointer;
  position: relative;
  z-index: 1;
  width: 160px;
  background-color: rgb(15, 15, 20);
  text-shadow: 0 0 0.125em hsl(0 0% 100% / 0.3), 0 0 0.45em currentColor;
  box-shadow: inset 0 0 0.1em 0 var(--clr-lang), 0 0 0.5em 0 var(--clr-lang);
}

.neon-select-container::before {
  pointer-events: none;
  content: '';
  position: absolute;
  background: var(--clr-lang);
  bottom: -25px;
  left: 0;
  width: 100%;
  height: 100%;
  transform: perspective(1em) rotateX(40deg) scale(1, 0.35);
  filter: blur(1em);
  opacity: 0.7;
  z-index: -1;
}

.neon-select::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  box-shadow: 0 0 2em 0.5em var(--clr-lang);
  opacity: 0;
  background-color: var(--clr-lang);
  z-index: -1;
  transition: opacity 100ms linear;
}
`, "",{"version":3,"sources":["webpack://./client/translatorCss/languageSelect.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,sBAAsB;EACtB,qCAAqC;EACrC,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,iCAAiC;EACjC,sEAAsE;EACtE,0EAA0E;AAC5E;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yDAAyD;EACzD,iBAAiB;EACjB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,yCAAyC;EACzC,UAAU;EACV,iCAAiC;EACjC,WAAW;EACX,gCAAgC;AAClC","sourcesContent":[":root {\r\n  --clr-lang: hsl(46, 100%, 50%);\r\n}\r\n\r\n.neon-select-container {\r\n  display: inline-block;\r\n  position: relative;\r\n}\r\n\r\n.neon-select {\r\n  font-size: 20px;\r\n  background-color: transparent;\r\n  color: var(--clr-lang);\r\n  border: var(--clr-lang) 0.125em solid;\r\n  padding: 0.25em 1em;\r\n  border-radius: 0.25em;\r\n  cursor: pointer;\r\n  position: relative;\r\n  z-index: 1;\r\n  width: 160px;\r\n  background-color: rgb(15, 15, 20);\r\n  text-shadow: 0 0 0.125em hsl(0 0% 100% / 0.3), 0 0 0.45em currentColor;\r\n  box-shadow: inset 0 0 0.1em 0 var(--clr-lang), 0 0 0.5em 0 var(--clr-lang);\r\n}\r\n\r\n.neon-select-container::before {\r\n  pointer-events: none;\r\n  content: '';\r\n  position: absolute;\r\n  background: var(--clr-lang);\r\n  bottom: -25px;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  transform: perspective(1em) rotateX(40deg) scale(1, 0.35);\r\n  filter: blur(1em);\r\n  opacity: 0.7;\r\n  z-index: -1;\r\n}\r\n\r\n.neon-select::after {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  box-shadow: 0 0 2em 0.5em var(--clr-lang);\r\n  opacity: 0;\r\n  background-color: var(--clr-lang);\r\n  z-index: -1;\r\n  transition: opacity 100ms linear;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
